var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Info",
    fill: "#B7844D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,53 C41.13489,53 53,41.13489 53,26.5 C53,11.86511 41.13489,0 26.5,0 C11.86511,0 0,11.86511 0,26.5 C0,41.13489 11.86511,53 26.5,53 Z M26.5,48.182406 C38.47482,48.182406 48.1823,38.474926 48.1823,26.500106 C48.1823,14.525286 38.47482,4.817806 26.5,4.817806 C14.52518,4.817806 4.8177,14.525286 4.8177,26.500106 C4.8177,38.474926 14.52518,48.182406 26.5,48.182406 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "translate(20.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75,10.125 L8.54068385,10.125 L1.66273542,11.0907645 L1.41076979,11.7930916 C1.67937466,11.7785999 1.92302066,11.7708365 2.14170781,11.7708365 C2.57848784,11.7708365 2.92672335,11.8733131 3.18760285,12.0782664 C3.4478881,12.2832196 3.57803072,12.5171561 3.57803072,12.7800759 C3.57803072,13.1899824 3.44313403,13.7970787 3.17512342,14.6013648 L0.352395319,23.0499923 C0.116474675,23.7228186 0,24.2786766 0,24.7175663 C0,25.3759009 0.260285244,25.9208902 0.780855732,26.3525341 C1.30142622,26.7836605 1.9984915,27 2.87205156,27 C5.17302066,27 7.34800695,25.4493943 9.39760468,22.3481828 L8.69221978,21.9962429 C7.8519382,23.1374597 7.12159444,23.9272543 6.5,24.366144 C6.28131285,24.5415964 6.05490035,24.6295814 5.81957396,24.6295814 C5.68527153,24.6295814 5.55928872,24.5710972 5.44221978,24.454129 C5.32455659,24.3371607 5.265725,24.2201925 5.265725,24.1032242 C5.265725,23.8692877 5.37447431,23.3936513 5.59375571,22.6768325 L9.75,10.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72271637,0 C8.8230062,0 8.06036378,0.332528861 7.43608835,0.996914809 C6.81246252,1.66130076 6.5,2.45869825 6.5,3.38910729 C6.5,4.31951632 6.81700979,5.11221139 7.45037977,5.76719248 C8.08374975,6.42217357 8.84119528,6.75 9.72271637,6.75 C10.6224265,6.75 11.3935139,6.42217357 12.036628,5.76719248 C12.6790925,5.11221139 13,4.31951632 13,3.38910729 C13,2.45869825 12.6836398,1.66130076 12.0496202,0.996243033 C11.4162502,0.331857086 10.6406156,0 9.72271637,0 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.f743e5e2a247b7e6ea949af07c1bfa2e.svg";
export { ForwardRef as ReactComponent };